// src/components/Marketplace.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/App.css'; // Import the consolidated App.css

function Marketplace() {
  return (
    <main className="marketplace-page page-wrap text-center">
      <h1 className="mb-4">Marketplace</h1>
      <p className="mb-4">
        Our Marketplace is under construction. Stay tuned for exciting AI-enhanced workout gear,
        supplements, and more!
      </p>

      {/* Example dotLottie animation */}
      <dotlottie-player 
        src="https://lottie.host/5edb94cf-9992-48b2-bf7a-1437b9264f25/9pxvOoU1bA.lottie" 
        background="transparent" 
        speed="1" 
        style={{ width: '350px', height: '350px', margin: '0 auto' }}
        loop 
        autoplay
      >
      </dotlottie-player>
    </main>
  );
}

export default Marketplace;
